module.exports = __webpack_public_path__ + "img/loader-logo.baf0ba2c.png";